import React, { useState } from 'react';

function Menu() {
  const [showAll, setShowAll] = useState(false);

  // Popular Picks matching the exact 4 items in the reference image
  const popularPicks = [
    {
      id: 'strawberry-croissant',
      name: 'Strawberry Croissant',
      thName: 'ครัวซองต์สตรอว์เบอร์รี่สด & วิปครีม',
      price: '$6.50',
      thPrice: '฿120',
      image: '/img/image1.webp',
      badge: 'Bestseller'
    },
    {
      id: 'blueberry-bowl',
      name: 'Blueberry Yogurt Bowl',
      thName: 'กรีกโยเกิร์ตบลูเบอร์รี่โบว์ล & กราโนล่า',
      price: '$7.20',
      thPrice: '฿139',
      image: '/img/image.webp',
      badge: 'Signature'
    },
    {
      id: 'fig-honey-croissant',
      name: 'Fig & Honey Croissant',
      thName: 'ครัวซองต์ฟิกมะเดื่อฝรั่ง & น้ำผึ้งป่า',
      price: '$6.80',
      thPrice: '฿125',
      image: '/img/image3.webp',
      badge: 'Chef Special'
    },
    {
      id: 'banana-bowl',
      name: 'Banana Yogurt Bowl',
      thName: 'กรีกโยเกิร์ตกล้วยหอม & คาราเมลนัท',
      price: '$6.90',
      thPrice: '฿135',
      image: '/img/image4.webp',
      badge: 'Popular'
    }
  ];

  const menuItems = [
    { image: '/img/image.webp', title: 'Blueberry Bowl' },
    { image: '/img/image1.webp', title: 'Strawberry Croissant' },
    { image: '/img/image2.webp', title: 'Berry Bliss' },
    { image: '/img/image3.webp', title: 'Fig & Honey' },
    { image: '/img/image4.webp', title: 'Banana Nut' },
    { image: '/img/image5.webp', title: 'Kiwi Sparkle' },
    { image: '/img/image6.webp', title: 'Mango Sunshine' },
    { image: '/img/image7.webp', title: 'Grape Medley' },
    { image: '/img/image8.webp', title: 'Granola Crunch' },
    { image: '/img/image9.webp', title: 'Pure Greek Scoop' },
    { image: '/img/image10.webp', title: 'Fresh Berry Mix' },
    { image: '/img/image11.webp', title: 'Almond Honey' },
    { image: '/img/image12.webp', title: 'Peach Delight' },
    { image: '/img/image13.webp', title: 'Dark Choco Bowl' },
    { image: '/img/image14.webp', title: 'Matcha Greek' },
    { image: '/img/image15.webp', title: 'Summer Tropical' },
  ];

  return (
    <section id="popular" className="py-20 bg-white relative overflow-hidden">
      {/* Subtle Greek Aegean grid line background */}
      <div className="absolute inset-0 opacity-25 bg-[linear-gradient(to_right,#d0deef_1px,transparent_1px),linear-gradient(to_bottom,#d0deef_1px,transparent_1px)] bg-[size:32px_32px]"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Popular Picks Header matching reference image */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 pb-4 border-b border-brand-200/70 gap-4">
          <div className="flex items-center gap-3">
            <h2 className="font-serif text-3xl sm:text-4xl text-brand-800 font-semibold tracking-tight">
              Popular Picks
            </h2>
            {/* Olive sprig icon beside title */}
            <img
              src="/logo_small.png"
              alt="Olive sprig"
              className="w-7 h-7 object-contain transform -rotate-12"
            />
          </div>

          <button
            onClick={() => setShowAll(!showAll)}
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-brand-600 hover:text-brand-800 transition-colors"
          >
            {showAll ? 'Show Highlights' : 'View Full Menu'}
            <i className={`fas fa-arrow-right text-[11px] transform ${showAll ? 'rotate-90' : ''} transition-transform`}></i>
          </button>
        </div>

        {/* 4 Cards Grid matching image */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {popularPicks.map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-2xl border border-brand-200/80 shadow-xs hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden flex flex-col"
            >
              {/* Image Frame */}
              <div className="aspect-[4/3] w-full overflow-hidden bg-brand-50 relative">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 bg-white/90 backdrop-blur-xs text-brand-800 text-[10px] uppercase font-bold tracking-wider px-2.5 py-1 rounded-full shadow-2xs border border-brand-100">
                  {item.badge}
                </span>
              </div>

              {/* Card Meta matching image */}
              <div className="p-4 flex-1 flex flex-col justify-between border-t border-brand-100/70">
                <div>
                  <h3 className="font-serif text-lg font-medium text-brand-900 leading-snug group-hover:text-brand-600 transition-colors">
                    {item.name}
                  </h3>
                  <p className="text-[12px] text-brand-600/80 font-light mt-0.5">
                    {item.thName}
                  </p>
                </div>

                <div className="mt-4 pt-3 border-t border-brand-50 flex items-center justify-between">
                  <div className="flex items-baseline gap-1.5">
                    <span className="text-base font-semibold text-brand-700">
                      {item.price}
                    </span>
                    <span className="text-xs text-brand-400 font-light">
                      ({item.thPrice})
                    </span>
                  </div>

                  <a
                    href="#builder"
                    className="w-8 h-8 rounded-full bg-brand-50 hover:bg-brand-600 hover:text-white text-brand-600 flex items-center justify-center transition-all text-xs"
                    title="Add to Bowl"
                  >
                    <i className="fas fa-plus"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Expandable Full Menu Showcase */}
        {showAll && (
          <div className="mt-14 pt-10 border-t border-brand-200/70">
            <div className="text-center mb-8">
              <span className="text-xs uppercase tracking-[0.2em] text-brand-500 font-bold block mb-1">
                Artisanal Collection
              </span>
              <h3 className="font-serif text-2xl text-brand-900">
                Fresh From Our Kitchen Every Day
              </h3>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {menuItems.map((item, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-xl border border-brand-200/70 p-2 shadow-2xs hover:shadow-md transition-all group text-center"
                >
                  <div className="aspect-square rounded-lg overflow-hidden bg-brand-50 mb-2">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                    />
                  </div>
                  <span className="text-xs font-medium text-brand-800 truncate block">
                    {item.title}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

      </div>
    </section>
  );
}

export default Menu;
